import React from 'react';
import cx from 'classnames';
import './SMFooter.css';
import '../Footer.css';
import InstagramIcon from '../images/fff-instagram.svg';
import FacebookIcon from '../images/fff-facebook.svg';
import PinterestIcon from '../images/fff-pinterest.svg';
import TwitterIcon from '../images/fff-twitter.svg';
import YoutubeIcon from '../images/fff-youtube.svg';
import TiktokIcon from '../images/fff-tiktok.svg';
import UserWay from '../UserWay';

const iconImages = {
  InstagramIcon,
  FacebookIcon,
  PinterestIcon,
  TwitterIcon,
  YoutubeIcon,
  TiktokIcon,
};
export const SMFooter = ({ socialMedias, isTablet, isMobile, isLogin }) => {
  // eslint-disable-next-line react/destructuring-assignment
  const { icons } = socialMedias;
  const getTabletStyles = cx({
    'fff-shared-footer-top-section-col-logout': isTablet && isLogin,
  });

  const mappedIcons = () =>
    icons.map(({ id, route, img, icon }) => (
      <a key={id} href={route}>
        {icon || <img src={iconImages[img]} className="fff-shared-footer-sm-icons" alt="social" />}
      </a>
    ));

  return (
    <div
      className={`fff-shared-footer-sm-container fff-shared-footer-top-section-col ${getTabletStyles}`}
    >
      <div>
        {isTablet ? (
          mappedIcons()
        ) : (
          <div>
            {mappedIcons()}
            {!isMobile && <UserWay />}
          </div>
        )}
      </div>
    </div>
  );
};
